var exports = {
  "kL": "xcc377c0b--855ab5--container",
  "kb": "xcc377c0b--855ab5--left",
  "Qq": "xcc377c0b--855ab5--text",
  "o1": "xcc377c0b--855ab5--actions",
  "pG": "xcc377c0b--855ab5--right",
};

module.exports = exports;
